// ============================================================
// App Component
// Orchestrates which screen is showing. No business logic —
// just tracking which stage the user is at.
// ============================================================

import React, { useState } from 'react';
import Landing from './components/Landing';
import FreeTrial from './components/FreeTrial';
import Intake from './components/Intake';
import Question from './components/Question';
import Report from './components/Report';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import RefundPolicy from './components/RefundPolicy';
import ContactForm from './components/ContactForm';
import './App.css';

function App() {
  const [stage, setStage] = useState('landing'); // landing -> trial | intake -> questions -> report
  const [previousStage, setPreviousStage] = useState('landing'); // remembers where to return from policy pages
  const [sessionId, setSessionId] = useState(null);
  const [userInfo, setUserInfo] = useState({ name: '', email: '' });

  function handleSessionStarted(id, name, email) {
    setSessionId(id);
    setUserInfo({ name, email });
    setStage('questions');
  }

  function handleAssessmentComplete(id) {
    setSessionId(id);
    setStage('report');
  }

  function goToPolicy(policyStage) {
    setPreviousStage(stage);
    setStage(policyStage);
  }

  const POLICY_STAGES = ['privacy', 'terms', 'refund', 'contact'];

  return (
    <div className="app">
      {stage === 'landing' && (
        <Landing
          onStartTrial={() => setStage('trial')}
          onStartPaid={() => setStage('intake')}
          onShowPrivacy={() => goToPolicy('privacy')}
          onShowTerms={() => goToPolicy('terms')}
          onShowRefund={() => goToPolicy('refund')}
          onShowContact={() => goToPolicy('contact')}
        />
      )}
      {stage === 'trial' && <FreeTrial onExit={() => setStage('intake')} />}
      {stage === 'intake' && (
        <Intake onSessionStarted={handleSessionStarted} />
      )}
      {stage === 'questions' && (
        <Question sessionId={sessionId} onComplete={handleAssessmentComplete} />
      )}
      {stage === 'report' && (
        <Report sessionId={sessionId} name={userInfo.name} email={userInfo.email} />
      )}
      {stage === 'privacy' && <PrivacyPolicy onBack={() => setStage(previousStage)} />}
      {stage === 'terms' && <Terms onBack={() => setStage(previousStage)} />}
      {stage === 'refund' && <RefundPolicy onBack={() => setStage(previousStage)} />}
      {stage === 'contact' && <ContactForm onBack={() => setStage(previousStage)} />}

      {/* Persistent contact link — visible on every screen except the
          policy/contact pages themselves (to avoid a link to itself)
          and hidden from print output. */}
      {!POLICY_STAGES.includes(stage) && (
        <button
          className="persistent-contact-link no-print"
          onClick={() => goToPolicy('contact')}
        >
          Need help?
        </button>
      )}
    </div>
  );
}

export default App;
